let Playlists = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.form();
        this.delete();
        this.addToPlaylist();
        this.removeAlbumFromPlaylist();
        this.sort();
        this.sortAlbums();
    },

    delete: function () {
        $('.delete-playlist').click(function () {
            let id = $(this).data('id');
            let row = $(this).closest('tr');

            swal({
                title: "Are you sure?",
                text: "Your will not be able to recover this record!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.value) {
                    $.post('/playlists/' + id,
                        {
                            _method: 'delete'
                        },
                        (result) => {
                            if (result.success) {
                                let table = row.closest('table').DataTable();
                                table.row(row).remove().draw();
                                swal(
                                    'Deleted!',
                                    'Record has been deleted.',
                                    'success'
                                ).then((result) => {

                                });
                            }
                        });
                }
            });
        });
    },

    form: function () {
        let _this = this;
        const playlistForm = $('#playlistForm');

        if (playlistForm.length) {
            let submitBtn = Ladda.create(playlistForm.find('[type=submit]')[0]);

            playlistForm.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        toastr.success(response.message);
                        setTimeout(() => {
                            window.location.assign('/playlists/' + response.data.id + '/edit');
                        }, 1000);
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });
        }

        $('#playlists').on('draw.dt', function () {
            _this.delete();
        });

        const elem = $('#albumsAutocomplete')
        elem.select2({
            ajax: {
                url: '/playlists/albums/autocomplete',
                data: function (params) {
                    return {
                        q: params.term,
                        playlist: currentPlaylist
                    }
                },
                dataType: 'json',
                processResults: function (data) {
                    return {
                        results: data.items
                    };
                },
            },

            placeholder: 'Select Album ...',
            minimumInputLength: 3,
        });
    },

    addToPlaylist() {
        let _this = this;
        const playlistAlbumForm = $('#playlistAlbumForm');

        if (playlistAlbumForm.length) {
            let submitBtn = Ladda.create(playlistAlbumForm.find('[type=submit]')[0]);

            playlistAlbumForm.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    console.log(response);
                    if (response.success) {
                        toastr.success(response.message);
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                    submitBtn.stop();
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });
        }
    },

    removeAlbumFromPlaylist: function () {
        $('.remove-album-from-playlist').click(function () {
            let albumId = $(this).data('album');
            let playlistId = $(this).data('playlist');
            let row = $(this).closest('tr');

            swal({
                title: "Are you sure?",
                text: "Album will be removed from this playlist!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.value) {
                    $.post('/playlists/' + playlistId + '/albums/' + albumId,
                        {
                            _method: 'delete'
                        },
                        (result) => {
                            if (result.success) {
                                row.remove();
                                swal(
                                    'Deleted!',
                                    'Album has been removed.',
                                    'success'
                                ).then((result) => {

                                });
                            }
                        });
                }
            });
        });
    },

    sort() {
        const table = $('#playlists');
        table.sortable({
            items: 'tbody tr',
            stop: function (e, ui) {
                let order = [];
                const rows = ui.item.closest('table').find('tbody tr');

                rows.each((key, row) => {
                    order.push($(row).data('id'));
                });

                console.log(order);

                $.post('/playlists/reorder', {
                    order
                }, response => {
                });
            }
        });
    },

    sortAlbums() {
        const table = $('#playlistAlbumsTable');
        table.sortable({
            items: 'tbody tr',
            stop: function (e, ui) {
                let order = [];
                const rows = ui.item.closest('table').find('tbody tr');

                rows.each((key, row) => {
                    order.push($(row).data('id'));
                });

                console.log(order);

                $.post('/playlists/' + currentPlaylist + '/albums/reorder', {
                    order
                }, response => {
                });
            }
        });
    }
};

$().ready(function () {
    window.Playlists = Playlists;
    window.Playlists.init();
});
